import { combineReducers } from "redux";
import loginSlice from './Auth/Login/reducer'
import userSlice from './User/reducer'
import { vehicleReducer, vehicleGroupReducer } from "./Vehicle/reducer"; // import both reducers
import driverSlice from './Driver/reducer'
import bookinSlice from './Booking/reducer';
import customerSlice from './Customer/reducer';
import maintenanceSlice from './Maintenance/reducer';
import reminderSlice from './Reminder/reducer'
import incomeAndExpensesSlice from './Income&Expenses/reducer'
import company from './Company/reducer'
const rootReducer = combineReducers({
    login: loginSlice,
    user:userSlice,
    vehicle: vehicleReducer,
    vehicleGroup: vehicleGroupReducer,
    driver:driverSlice,
    booking:bookinSlice,
    customer:customerSlice,
    maintenance:maintenanceSlice,
    reminder:reminderSlice,
    incomeAndExpenses:incomeAndExpensesSlice,
    company:company,
});

export default rootReducer;